/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Pick_DateInputs */

const en_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a date`)
};

const es_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una fecha`)
};

const de_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie ein Datum`)
};

const zh_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择日期`)
};

const ar_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر تاريخاً`)
};

const fr_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez une date`)
};

const vi_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ngày`)
};

const sw_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chagua tarehe`)
};

const th_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกวันที่`)
};

const bs_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaberite datum`)
};

const ja_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を選ぶ`)
};

const ko_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`날짜 선택`)
};

const pt_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma data`)
};

const it_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli una data`)
};

const sv_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett datum`)
};

const nl_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een datum`)
};

const da_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg en dato`)
};

const nb_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg en dato`)
};

const fi_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse päivämäärä`)
};

const pl_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz datę`)
};

const ru_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите дату`)
};

const tr_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir tarih seçin`)
};

const hi_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तारीख चुनें`)
};

const id_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih tanggal`)
};

const ms_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih tarikh`)
};

const cs_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte datum`)
};

const el_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιλέξτε ημερομηνία`)
};

const he_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחרו תאריך`)
};

const af_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies 'n datum`)
};

const hu_booking_pick_date = /** @type {(inputs: Booking_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válassz dátumot`)
};

/**
* | output |
* | --- |
* | "Pick a date" |
*
* @param {Booking_Pick_DateInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_pick_date = /** @type {((inputs?: Booking_Pick_DateInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Pick_DateInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_pick_date(inputs)
	if (locale === "de") return de_booking_pick_date(inputs)
	if (locale === "zh") return zh_booking_pick_date(inputs)
	if (locale === "ar") return ar_booking_pick_date(inputs)
	if (locale === "fr") return fr_booking_pick_date(inputs)
	if (locale === "vi") return vi_booking_pick_date(inputs)
	if (locale === "sw") return sw_booking_pick_date(inputs)
	if (locale === "th") return th_booking_pick_date(inputs)
	if (locale === "bs") return bs_booking_pick_date(inputs)
	if (locale === "ja") return ja_booking_pick_date(inputs)
	if (locale === "ko") return ko_booking_pick_date(inputs)
	if (locale === "pt") return pt_booking_pick_date(inputs)
	if (locale === "it") return it_booking_pick_date(inputs)
	if (locale === "sv") return sv_booking_pick_date(inputs)
	if (locale === "nl") return nl_booking_pick_date(inputs)
	if (locale === "da") return da_booking_pick_date(inputs)
	if (locale === "nb") return nb_booking_pick_date(inputs)
	if (locale === "fi") return fi_booking_pick_date(inputs)
	if (locale === "pl") return pl_booking_pick_date(inputs)
	if (locale === "ru") return ru_booking_pick_date(inputs)
	if (locale === "tr") return tr_booking_pick_date(inputs)
	if (locale === "hi") return hi_booking_pick_date(inputs)
	if (locale === "id") return id_booking_pick_date(inputs)
	if (locale === "ms") return ms_booking_pick_date(inputs)
	if (locale === "cs") return cs_booking_pick_date(inputs)
	if (locale === "el") return el_booking_pick_date(inputs)
	if (locale === "he") return he_booking_pick_date(inputs)
	if (locale === "af") return af_booking_pick_date(inputs)
	if (locale === "hu") return hu_booking_pick_date(inputs)
	return en_booking_pick_date(inputs)
});